/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTriggeredActionRowsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'
import {GetTriggeredActionRowsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'


export const getTriggeredActionRows = (request: GetTriggeredActionRowsRequest, options?: CashRequestOptions) => post<GetTriggeredActionRowsRequest, GetTriggeredActionRowsResponse>("/2.0/cash/get-triggered-action-rows", request, {...options, rejectOnError: true })